import CheckLogged from "./CheckLogged";
import CheckNotLogged from "./CheckNotLogged";

export default {
  CheckNotLogged,
  CheckLogged,
};
